{
    "Page_Title": "Actions d'administration",
    "Action_Label_MC": "Passer un appel",
    "Action_Label_MCC": "Appel de consultation",
    "Action_Label_MDT": "Composez la tonalité DTMF",
    "Action_Label_CC": "Appel clair (via le contrôle des appels)",
    "Action_Label_CCCM": "Clear Call (Via Call Model)",
    "Action_Label_CX": "Clear Connection",
    "Action_Label_AC": "Répondre à l'appel",
    "Action_Label_HD": "Appel en attente",
    "Action_Label_PC": "Appel du parc",
    "Action_Label_RC": "Récupérer l'appel",
    "Action_Label_ATC": "Appel alternatif",
    "Action_Label_PUC": "Appel de prise en charge",
    "Action_Label_TO": "Transfert en une étape",
    "Action_Label_TR": "Transfert terminé",
    "Action_Label_DF": "Détourner\/Dévier l'appel",
    "Action_Label_MONC": "Connexion du moniteur",
    "Action_Label_REC": "Appel d'enregistrement",
    "Action_Label_CBMSG": "Rappel d'inscription",
    "Action_Label_CO": "Participer à la conférence",
    "Action_Label_MES": "Démarrer le moniteur",
    "Action_Label_MEP": "Arrêt du moniteur",
    "Action_Label_SDND": "Définir l'état DNS",
    "Action_Label_SACD": "Définir l'état ACD",
    "Action_Label_SFWD": "Définir l'état avancé",
    "Action_Label_SACC": "Définir le code du compte",
    "Action_Label_SPWD": "Définir le mot de passe de l'entité",
    "Action_Label_QDND": "Consulter le statut du mode Ne pas déranger",
    "Action_Label_QACD": "Interroger l'état ACD",
    "Action_Label_QFWD": "État de la requête transmise",
    "Action_Label_SPC": "Appel instantané",
    "Action_Label_SPD": "Dispositif de capture d'écran",
    "AcdOption_SignIn": "Se connecter",
    "AcdOption_SignOut": "Se déconnecter",
    "AcdOption_Available": "Disponible",
    "AcdOption_NotAvailable": "Pas disponible",
    "AcdOption_AlertingAcd": "Alerte (ACD)",
    "AcdOption_AlertingNonAcd": "Alerte (hors ACD)",
    "AcdOption_BusyAcd": "Occupé (ACD)",
    "AcdOption_BusyNonAcd": "Occupé (non ACD)",
    "AcdOption_BusySupervisor": "Occupé (Superviseur)",
    "AcdOption_AcdDnd": "ACD-DND",
    "AcdOption_WrapUp": "Conclure",
    "ForwardOption_None": "Aucun",
    "ForwardOption_Immediate": "Immédiat",
    "ForwardOption_OnBusy": "En cours d'utilisation",
    "ForwardOption_NoAnswer": "Aucune réponse",
    "ForwardOption_OnDnd": "Sur DND",
    "ForwardOption_OnOos": "En rupture de stock",
    "Field_Label_DeviceMain": "Appareil",
    "Field_Label_Destination": "Destination",
    "Field_Label_CallIDMain": "ID d'appel actif",
    "Field_Label_DestinationAutoPrefix": "Destination avec préfixe automatique ?",
    "Field_Label_CallIDHeld": "Autre identifiant d'appel",
    "Field_Label_DTMFTones": "Tonalités DTMF",
    "Field_Label_ParkLocation": "Emplacement du parc",
    "Field_Label_OtherCallID": "Autre identifiant d'appel",
    "Field_Label_DeviceToPickupAt": "Appareil à récupérer à",
    "Field_Label_CallParked": "Appel stationné",
    "Field_Label_MonitorType": "Type de moniteur",
    "Field_Label_Password": "Mot de passe",
    "Field_Label_UseSecurePassword": "Utiliser un mot de passe sécurisé ?",
    "Field_Label_MonitorCrossRefID": "ID de référence croisée du moniteur",
    "Field_Label_IsDND": "Activation\/désactivation du mode Ne pas déranger",
    "Field_Label_AgentID": "ID de l'agent",
    "Field_Label_ACDGroup": "Groupe ACD",
    "Field_Label_ACDStateReasonTextID": "ACDStateReasonTextID",
    "Field_Label_ACDStatus": "État ACD",
    "Field_Label_ForwardMode": "État avancé",
    "Field_Label_AccountCode": "Code de compte",
    "Field_Label_PasswordOld": "Ancien mot de passe",
    "Field_Label_PasswordNew": "Nouveau mot de passe",
    "Field_Label_TelephonyServer": "Serveur de téléphonie",
    "Field_Label_Partition": "Partition",
    "Field_Label_CME": "Formation médicale continue",
    "Action_Button_Label_Execute": "Exécuter",
    "Action_Button_Label_Reset": "Réinitialiser",
    "NAME": "AdminActionsLanguage",
    "Action_Label": "Action",
    "Action_Label_GUC": "Obtenir la politique de conformité des utilisateurs",
    "Action_Label_AAP": "Appliquer la politique de capture d'Akixi",
    "Action_Label_QPS": "Statut de présence de la requête",
    "Action_Label_DUP": "Supprimer la politique utilisateur",
    "Action_Label_GT": "Trouver un locataire",
    "Action_Label_DT": "Supprimer le locataire",
    "Action_Label_GU": "Obtenir des utilisateurs",
    "Action_Label_GVA": "Téléchargez des applications vocales",
    "Field_Label_SilentMonitor": "Moniteur silencieux",
    "Field_Label_ForcedIntrude": "Intrusion forcée",
    "Field_Label_Policies": "Politiques"
}